import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi"}/>
}
